"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumLocalNetLabelGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const AltiumLabelTypeNameUtil_1 = require("./AltiumLabelTypeNameUtil");
class AltiumLocalNetLabelGroupingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, hierarchy) {
        this.mergeLocalNetLabelsRecursively(manager, hierarchy);
        return manager;
    }
    mergeLocalNetLabelsRecursively(manager, hierarchy) {
        this.mergeLocalNetLabels(manager, hierarchy.instance);
        for (const child of hierarchy.children) {
            this.mergeLocalNetLabelsRecursively(manager, child);
        }
    }
    mergeLocalNetLabels(manager, instance) {
        const groupsByName = new Map();
        const allGroups = new Set();
        const labels = manager.findGroupsWithLabel('net-label', undefined, instance).flatMap((group) => group
            .getNetLabels(instance)
            .filter((label) => label.labelType === 'net-label' &&
            label.strategyMetadata?.hiddenNetName === undefined &&
            !label.strategyMetadata?.harness?.isCarrier &&
            Boolean(label.originalLabel.trim()))
            .map((label) => ({ group, label })));
        const busRangeMemberNames = new Set(labels
            .filter(({ label }) => label.strategyMetadata?.busRangeMember)
            .map(({ label }) => label.originalLabel.toLowerCase()));
        const addGroup = (key, group) => {
            if (!groupsByName.has(key)) {
                groupsByName.set(key, new Set());
            }
            const groups = groupsByName.get(key);
            if (groups === undefined) {
                throw new Error(`Missing local net-label group for ${key}`);
            }
            groups.add(group);
            allGroups.add(group);
        };
        for (const { group, label } of labels) {
            addGroup(`normal:${JSON.stringify([
                (label.formattedLabel ?? label.originalLabel).toLowerCase(),
                label.originalLabel.toLowerCase(),
            ])}`, group);
            const formattedName = AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.maybeDereferenceLabelName(label.formattedLabel ?? label.originalLabel).toLowerCase();
            if (label.strategyMetadata?.busRangeMember) {
                addGroup(`bus-member:${label.originalLabel.toLowerCase()}`, group);
            }
            const isRepeatedSheetEntryIsland = group
                .getNetLabels(instance)
                .some((candidate) => candidate.labelType === 'sheet-entry' &&
                candidate.strategyMetadata?.['sheet-entry-metadata']?.isRepeated === true);
            if (isRepeatedSheetEntryIsland && busRangeMemberNames.has(formattedName)) {
                addGroup(`bus-member:${formattedName}`, group);
            }
        }
        const parent = new Map();
        const find = (group) => {
            const currentParent = parent.get(group);
            if (!currentParent) {
                parent.set(group, group);
                return group;
            }
            if (currentParent === group) {
                return group;
            }
            const root = find(currentParent);
            parent.set(group, root);
            return root;
        };
        const union = (a, b) => {
            const rootA = find(a);
            const rootB = find(b);
            if (rootA !== rootB) {
                parent.set(rootB, rootA);
            }
        };
        for (const groups of groupsByName.values()) {
            const groupList = Array.from(groups);
            for (let i = 1; i < groupList.length; i++) {
                union(groupList[0], groupList[i]);
            }
        }
        const groupsByRoot = new Map();
        for (const group of allGroups) {
            const root = find(group);
            if (!groupsByRoot.has(root)) {
                groupsByRoot.set(root, []);
            }
            const rootGroups = groupsByRoot.get(root);
            if (rootGroups === undefined) {
                throw new Error(`Missing local net-label root group`);
            }
            rootGroups.push(group);
        }
        for (const groups of groupsByRoot.values()) {
            if (groups.length > 1) {
                manager.mergeGroups(...groups);
            }
        }
    }
}
exports.AltiumLocalNetLabelGroupingRule = AltiumLocalNetLabelGroupingRule;
//# sourceMappingURL=AltiumLocalNetLabelGroupingRule.js.map